<template>
    <!-- 星级评分 -->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" style="margin-left:5px">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                 {{number}}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                <el-input placeholder="请输入题目内容" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName"
                          autosize></el-input>
            </el-col>
            <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <i class="el-icon-delete delete" v-if="index==editIndex" @click="questiondel(question.id)"></i>
                <el-badge 
          v-if="question.displayscriptcount || question.jumpscriptcount" 
          :value="question.displayscriptcount + question.jumpscriptcount" 
          class="item">
          <i
            class="el-icon-share"
            @click="()=>$emit('jumpshow',question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
            </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;" v-for="(childItem,childindex) in question.optionList"
                :key="index+'_'+childindex">
            <div @click="setEditOptionIndex(childindex)">
                <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                        class="el_item_option item_container_title" style="margin-left:50px">
                    <div class="inputvalue">
                        <ul class="ul_rate" >
                            <li v-for="(n,index) in (question.most - question.least + 1)" :key="index" @click="selected('评分',n)">
                                <img v-show="cur<n && question.scoreImg == 'star'"  :src="rateDataList[0].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'star'"  :src="rateDataList[0].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'heart'"  :src="rateDataList[1].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'heart'"  :src="rateDataList[1].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'smile'"  :src="rateDataList[2].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'smile'"  :src="rateDataList[2].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'thumb'"  :src="rateDataList[3].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'thumb'"  :src="rateDataList[3].checkedImg" alt="">
                            </li>
                        </ul>
                        <div class="tips" >
                            <span  v-if="question.scoreAnnotation != ''">{{ JSON.parse(question.scoreAnnotation).left }}</span>
                            <span  v-if="question.scoreAnnotation != ''">{{ JSON.parse(question.scoreAnnotation).center }}</span>
                            <span  v-if="question.scoreAnnotation != ''">{{ JSON.parse(question.scoreAnnotation).right }}</span>
                        </div>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                select:true,
                cur:-1,
                imgIndex:0,
                rateDataList: [ 
                    { 
                        bgImg: require('@/assets/rate/stars.png'),
                        checkedImg:require('@/assets/rate/star_def.png'),
                        unCheckedImg: require('@/assets/rate/star_sel.png'), 
                        value: 'star'
                    },
                    { 
                        bgImg: require('@/assets/rate/heart.png'),
                        checkedImg:require('@/assets/rate/heart_def.png'),
                        unCheckedImg: require('@/assets/rate/heart_sel.png'),
                        value: 'heart'
                    },
                    { 
                        bgImg: require('@/assets/rate/smile.png'),
                        checkedImg:require('@/assets/rate/laugh_def.png'),
                        unCheckedImg: require('@/assets/rate/laugh_sel.png'),
                        value: 'smile'
                    },
                    { 
                        bgImg: require('@/assets/rate/good.png'),
                        checkedImg:require('@/assets/rate/good_def.png'),
                        unCheckedImg: require('@/assets/rate/good_sel.png'),
                        value: 'thumb'
                    },
                ],
            }
        },
        props: {
			number: { type: Number, default: 0 },
            question: {},
            editOptionIndex: {type:String,default:"0_0"},
            editIndex: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            index: {type:Number,default:0},
            tipsObj: {type: Object},
            imageUrl:{type:Object}
        },
        methods: {
            selected(msg,n){
                this.cur = n;
                console.log(msg,n)
            },
            updateQuestion(){
                this.$emit("wjupdquestionoption",this.question);
            },
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            showAdvance(e) {
                this.$emit("showAdvance",e);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            setEditOptionIndex(childIndex){
                this.$emit("setEditOptionIndex",childIndex)
            },
            questiondel(id){
                this.$emit("questiondel",id);
            },
        },
        created() {
        //    console.log(this.question)
        //    console.log(this.question.scoreImg)
        }
    }
</script>

<style scoped>
    .ul_rate {
        display:flex;
        justify-content: space-between;
    }
    .ul_rate li{
        /* margin-right:15px; */
    }
    .delete,.item {
        font-size: 22px !important;
        line-height: 40px !important;
        margin-right: 30px !important;
        text-align: right;
        float: right;
        cursor: pointer;
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        /* line-height: 40px; */
        /* height: 44px; */
        
    }
    .inputvalue .tips{
        height: 30px;
        padding-top: 5px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #aaaaaa;
    }
    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }
    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }
    .askxh {
        line-height: 40px;
        text-align: right;
    }
    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .item_container_title:hover {
    //border: 1px darkgrey dashed;

    }
</style>
